import { render, staticRenderFns } from "./UpdateHubOPC.vue?vue&type=template&id=6fa6666b"
import script from "./UpdateHubOPC.vue?vue&type=script&lang=js"
export * from "./UpdateHubOPC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports